import * as React from 'react';
import { BaSeParagraph, BaSeSmall2, BaSeTheme } from '@base/react';

export const LabelTitle = ({ label, subLabel, subTitle, isItalic, link, onLinkClick }) => (
  <div style={{ padding: '4px 0' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
        {label}
      </BaSeParagraph>
      {subLabel && (
        <BaSeParagraph
          isItalic
          color={BaSeTheme.colors.institucionais.cinzaSebrae60}
        >
          {subLabel}
        </BaSeParagraph>
      )}
      {link && (
        <BaSeSmall2 link="#" onClick={onLinkClick}>
          {link}
        </BaSeSmall2>
      )}
    </div>
    {subTitle && (
      <BaSeSmall2
        color={BaSeTheme.colors.institucionais.cinzaSebrae45}
        isItalic={isItalic}
      >
        {subTitle}
      </BaSeSmall2>
    )}
  </div>
);
